export const PROMOTIONS = 'promotions';
export const ENTER_DRAW_ACTION = 'enterDrawAction';

export const ALL_TAG = 'All promos';

export const NUMBER_OF_ELEMENTS_WITH_SMALL_GAP = 3;

export enum PROMO_ACTIONS {
    atpLaunch = 'atpLaunch',
    gameLaunch = 'gameLaunch',
    linkToPromo = 'linkToPromo',
    internalLink = 'internalLink',
    externalLink = 'externalLink',
}
